
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/associations/[associationId]/settings/forms/[formId]",
      function () {
        return require("private-next-pages/associations/[associationId]/settings/forms/[formId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/associations/[associationId]/settings/forms/[formId]"])
      });
    }
  